import {useCallback, useRef} from 'react'
import {useRails} from '~/react/contexts/rails'

import useFormSchema from './useFormSchema'
import {createPayment} from '../../../api'
import {MAXIMUM_REFERENCE_LENGTH} from '../constants'

export default function useFormSubmit(payable) {
  const {authenticityToken, currentSupplier} = useRails()
  const submittedRef = useRef(false)

  const onSubmit = useCallback(
    async (values) => {
      if (submittedRef.current) return false

      submittedRef.current = true

      try {
        const result = await createPayment({
          supplierId: currentSupplier.id,
          authenticityToken,
          params: {
            payment: {
              ...values,
              amount: {
                cents: values.amount,
                currency: 'AUD',
              },
            },
          },
        })

        return {success: true, data: result}
      } catch (error) {
        return {
          success: false,
          error: {code: error.code, message: error.message},
        }
      } finally {
        submittedRef.current = false
      }
    },
    [authenticityToken, currentSupplier.id],
  )

  const formSchema = useFormSchema(payable)

  return {
    initialValues: {
      amount: payable?.dueAmount?.getAmount() || 0,
      reference: (payable.billNumber || '').slice(0, MAXIMUM_REFERENCE_LENGTH),
    },
    validationSchema: formSchema,
    paymentSubmitted: submittedRef.current,
    createPayment: onSubmit,
  }
}
